import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import { TableSlideProps } from '../types';
import '../styles/TableSlide.css';

const TableSlide: React.FC<TableSlideProps> = ({
  title,
  subtitle,
  headers,
  rows,
  paymentTermsBox,
  footer
}) => {
  return (
    <SlideLayout footer={footer} className="table-slide">
      <div className="table-slide-wrapper">
        <div className="table-header-section">
          <div className="table-header-left">
            <h2 className="table-title">{title}</h2>
            {subtitle && <p className="table-subtitle">{subtitle}</p>}
          </div>
          
          {paymentTermsBox && (
            <div className="table-payment-terms-box">
              {paymentTermsBox}
            </div>
          )}
        </div>

        <div className="table-container">
          <table className="pricing-table">
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {headers.map((header, cellIndex) => (
                    <td key={cellIndex}>{row[header]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </SlideLayout>
  );
};

export default TableSlide;
